export enum OnboardingStep {
  PERSONAL_INFO = "personal-info",
  COMPANY_INFO = "company-info",
  INVITE_TEAMMATES = "invite-teammates",
  SET_PASSWORD = "set-password",
}
